import { render } from "./CreateQuote.vue?vue&type=template&id=b418892e&ts=true"
import script from "./CreateQuote.vue?vue&type=script&lang=ts"
export * from "./CreateQuote.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__